module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/premier_desktop-54841274823569e6cb88b3ee2c19e2f9.jpg";